import {Spin} from 'antd';
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

const FullscreenLoading = () => {
  const { loading } = useSelector((s) => s.loading);
  const [visible, setVisible] = useState(loading);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setVisible(loading);
    }, 300);

    return () => {
      clearTimeout(timeout);
    };
  }, [loading]);

  if (!visible) {
    return null;
  }

  return (
    <div
      className={`fullscreen-loading w-100 h-100 d-flex align-items-center justify-content-center ${
        loading ? 'visible' : ''
      }`}
    >
      <Spin size="large" />
    </div>
  );
};

export default FullscreenLoading;
